import React from 'react'
import { Box, Typography, makeStyles, Theme } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
    panel: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.75),
        width: '100%',
        padding: theme.spacing(1, 1.25),
        borderRadius: 8,
        border: `1px solid ${theme.palette.divider}`,
        borderLeftWidth: 3,
        backgroundColor: theme.palette.grey[50],
        boxSizing: 'border-box',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.75),
    },
    icon: {
        flexShrink: 0,
        width: 26,
        height: 26,
        borderRadius: 7,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg': {
            fontSize: 16,
        },
    },
    title: {
        fontSize: '0.8125rem',
        fontWeight: 700,
        lineHeight: 1.3,
        color: theme.palette.text.primary,
    },
    body: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.75),
        minWidth: 0,
    },
}))

export type PhaseControlPanelTone = {
    accent: string
    iconBg: string
    iconColor: string
}

export const PHASE_PANEL_TONES = {
    invite: {
        accent: '#2E7D32',
        iconBg: '#E8F5E9',
        iconColor: '#2E7D32',
    },
    applicant: {
        accent: '#1565C0',
        iconBg: '#E3F2FD',
        iconColor: '#1565C0',
    },
    fee: {
        accent: '#EF6C00',
        iconBg: '#FFF3E0',
        iconColor: '#EF6C00',
    },
    screening: {
        accent: '#6A1B9A',
        iconBg: '#F3E5F5',
        iconColor: '#6A1B9A',
    },
    qualification: {
        accent: '#00838F',
        iconBg: '#E0F7FA',
        iconColor: '#00838F',
    },
    documents: {
        accent: '#455A64',
        iconBg: '#ECEFF1',
        iconColor: '#455A64',
    },
} as const

export const PhaseControlPanel: React.FC<{
    title: string
    icon: React.ReactNode
    tone: PhaseControlPanelTone
    children: React.ReactNode
}> = ({ title, icon, tone, children }) => {
    const classes = useStyles()
    return (
        <Box className={classes.panel} style={{ borderLeftColor: tone.accent }}>
            <Box className={classes.header}>
                <Box
                    className={classes.icon}
                    style={{
                        backgroundColor: tone.iconBg,
                        color: tone.iconColor,
                    }}
                >
                    {icon}
                </Box>
                <Typography className={classes.title}>{title}</Typography>
            </Box>
            <Box className={classes.body}>{children}</Box>
        </Box>
    )
}
